import { createNamespacedAction } from "app/pages/sales-intelligence/store/utils";
import type { PaginatedTableRequest } from "app/pages/sales-intelligence/types/table";
import type { SortOrder } from "app/pages/sales-intelligence/utils/sort";

import type { BaseLeadsSearchRow, LeadsType, TableRecord, TableRowKey } from "../types";
import type { ExpandedRowVariant } from "../types/expanded-row";

import type { LeadsTabActionPayload } from "./types";

const createLeadsSearchAction = createNamespacedAction("si/leads-search");

export const setIsRowSelectionEnabled = createLeadsSearchAction<boolean>("set-is-row-selection-enabled");

export const setSelectedRows = createLeadsSearchAction<readonly TableRecord<BaseLeadsSearchRow>[]>("set-selected-rows");

export const resetTabsPagination = createLeadsSearchAction<void>("reset-tabs-pagination");

/** Apply or restore default sort when territory (team) filters are toggled or the selected team changes. */
export const applyTerritoryTableSort = createLeadsSearchAction<boolean>("apply-territory-table-sort");

export const setActiveLeadsType = createLeadsSearchAction<LeadsType>("set-active-leads-type");

export const setColumnNamesForHighlight = createLeadsSearchAction<readonly string[]>("set-column-names-for-highlight");

export const setTableRequestParams =
    createLeadsSearchAction<LeadsTabActionPayload<Partial<PaginatedTableRequest>>>("set-table-request-params");

export const setSearchText = createLeadsSearchAction<string>("set-search-text");
export const resetSearchText = createLeadsSearchAction<void>("reset-search-text");

export const setExpandedRowPage = createLeadsSearchAction<number>("set-expanded-row-page");

export const setExpandedRowSort = createLeadsSearchAction<{ columnKey: string; order: SortOrder }>(
    "set-expanded-row-sort",
);

export const toggleExpandedRow = createLeadsSearchAction<{ key: TableRowKey; variant: ExpandedRowVariant }>(
    "toggle-expanded-row",
);

export const setUseAggregatedCountryData = createLeadsSearchAction<boolean>("set-use-aggregated-country-data");

export const setIsOpenListPanel = createLeadsSearchAction<boolean>("set-is-open-list-panel");

export const setHighlightedRowDomains = createLeadsSearchAction<string[]>("set-highlighted-row-domains");
